import ILicenseSettings from '@/app/common/model/ILicenseImage';
import IRootState from '@/app/common/model/IRootState';
import ILanguage from '@/app/common/model/ILanguage';
import ITranslation from '@/app/common/model/ITranslation';
import ILicense from '@/app/common/model/ILicense';

const mutations = {
  setLanguages(state: IRootState, languageList: ILanguage[]) {
    state.languageList = languageList;
  },
  setLoadingState(state: IRootState, loadingState: boolean) {
    state.loading = loadingState;
  },
  saveLicense(state: IRootState, { license, reCaptcha }: ILicense) {
    state.license = license;
    state.reCaptcha = reCaptcha;
  },
  setTranslations(
    state: IRootState,
    { translations, shortcut }: { translations: ITranslation; shortcut: string },
  ) {
    state.currentLang = shortcut;
    state.translations = translations;
  },
  setImages(state: IRootState, licenseImages: ILicenseSettings) {
    state.licenseImages = licenseImages;
  },
  setMenuLogo(state: IRootState, menuImage: ILicenseSettings) {
    state.menuLogo = menuImage;
  },
  setUserSettings(state: IRootState, userSettings: ILicenseSettings) {
    state.userSettings = userSettings;
  },
};

export default mutations;
